import { render } from "./CategorySpendChart.vue?vue&type=template&id=05ac77ee&scoped=true"
import script from "./CategorySpendChart.vue?vue&type=script&lang=js"
export * from "./CategorySpendChart.vue?vue&type=script&lang=js"

import "./CategorySpendChart.vue?vue&type=style&index=0&id=05ac77ee&scoped=true&lang=scss"

import exportComponent from "/Users/zayed-lune/Desktop/Lunedata/lune-dashboard/dashboard-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05ac77ee"],['__file',"src/components/CategorySpendChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05ac77ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05ac77ee', __exports__)) {
    console.log('reload')
    api.reload('05ac77ee', __exports__)
  }
  
  module.hot.accept("./CategorySpendChart.vue?vue&type=template&id=05ac77ee&scoped=true", () => {
    console.log('re-render')
    api.rerender('05ac77ee', render)
  })

}


export default __exports__